import React, { useState} from 'react';
import {Fab} from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import { Container } from './styles';

export function BtnFullScreenBi({idElement, handleHeight, hasBtnText, animateBtn, posBtnActive, dirBtnText, styles}) {
	const [modoFull, setModoFull] = useState(true);

	const openFullscreen = () => {

		if(!idElement) {
			return false;
		}

		const elem = document.getElementById(idElement);
		console.log(elem);
		if (elem.requestFullscreen) {
			elem.requestFullscreen();
		}
		else if (elem.mozRequestFullScreen) {
			elem.mozRequestFullScreen();
		}
		else if (elem.webkitRequestFullscreen) {
			elem.webkitRequestFullscreen();
		}
		else if (elem.msRequestFullscreen) {
			elem.msRequestFullscreen();
		}
		console.log(handleHeight)
		handleHeight("100%")
	}

	const closeFullscreen = () => {
		console.log(document);
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) { /* Safari */
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) { /* IE11 */
			document.msExitFullscreen();
		}

		handleHeight('', true);
	}

	const handleClickFullScreen = () => {
		if (modoFull) {
			openFullscreen();
			setModoFull(false);
		} else {
			closeFullscreen();
			setModoFull(true);
		}
	};

	return (
		<Container 
		className={`btn-full-screen ${modoFull ? '' : 'active'} ${animateBtn ? 'animate' : ''} ${posBtnActive ? posBtnActive : ''} ${dirBtnText ? dirBtnText : ''} `}
		
		top={styles?.top} left={styles?.left} transform={styles?.transform}
		width={styles?.width} height={styles?.height} bgc={styles?.bgc} br={styles?.br} bgcHover={styles?.bgcHover} 
		>
			<Fab size="small" color="secondary" aria-label="fullScreen" onClick={handleClickFullScreen}>
				{modoFull ? (
					<FullscreenIcon />
				) : (
						<FullscreenExitIcon />
					)}
				{hasBtnText ?(
					<div className="textBtn">
					<span>Tela Cheia</span>
					</div>
				): ''}
			</Fab>
		</Container>
	)
}